import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

/** govuk/components/back-link */
export function BackLink({ to, children }: { to: string; children?: ReactNode }) {
  const { t } = useTranslation();
  return (
    <Link to={to} className="govuk-back-link">
      {children ?? t('common.back')}
    </Link>
  );
}
